// Kaizen Dashboard layouts
import ErrorHandler from "components/ErrorHandler";
import SignIn from "layouts/authentication/sign-in";

// Kaizen Dashboard icons
import { Assignment, AttachMoney, Business, Hail, People, Subject } from "@mui/icons-material";
import Preinscripcion from "layouts/authentication/preinscripcion";
import Empleados from "layouts/empleados";
import Empresas from "layouts/empresas";
import ResponsableTecnico from "layouts/responsableTecnico";
import Tasas from "layouts/tasas";
import MisEmpresas from "layouts/mis-empresas";
import DeclaracionesJuradas from "layouts/declaraciones-juradas";
import DeclaracionJurada from "layouts/declaracion";
import MiEmpresa from "layouts/mi-empresa";
import PdfDeclaracion from "layouts/pdfDeclaracion";
import DatosDeclaracion from "layouts/datosDeclaracion";

import Manifiestos from "layouts/manifiestos";

const routes = [
  {
    type: "collapse",
    name: "Empresas",
    key: "empresas",
    route: "/empresas",
    permissionId: 221,
    icon: <Business />,
    component: <Empresas />,
    noCollapse: true,
    permiso: "Empleados",
  },
  {
    type: "collapse",
    name: "Res. Técnicos",
    key: "responsables-tecnicos",
    route: "/responsables-tecnicos",
    permissionId: 231,
    icon: <Hail />,
    component: <ResponsableTecnico />,
    noCollapse: true,
    permiso: "Empleados",
  },
  { type: "collapse", name: "Manifiestos", key: "manifiestos", route: "/manifiestos", icon: <Assignment />, component: <Manifiestos />, noCollapse: true, permiso: "Manifiestos", permissionId: 211 },
  {
    type: "collapse",
    name: "Datos DDJJ",
    key: "datos-declaracion",
    route: "/datos-declaracion",
    permissionId: 251,
    icon: <Subject />,
    component: <DatosDeclaracion />,
    noCollapse: true,
    permiso: "Empleados",
  },
  {
    type: "collapse",
    name: "Tasas",
    key: "tasas",
    route: "/tasas",
    permissionId: 261,
    icon: <AttachMoney />,
    component: <Tasas />,
    noCollapse: true,
    permiso: "Empleados",
  },
  {
    type: "collapse",
    name: "Empleados",
    key: "empleados",
    route: "/empleados",
    permissionId: 241,
    icon: <People />,
    component: <Empleados />,
    noCollapse: true,
    permiso: "Empleados",
  },
  {
    type: "collapse",
    name: "Mis empresas",
    key: "mis-empresas",
    route: "/mis-empresas",
    icon: <Hail />,
    component: <MisEmpresas />,
    noCollapse: true,
    permiso: "Responsable",
  },
  {
    type: "collapse",
    name: "Empresa",
    key: "empresa",
    route: "/empresa",
    icon: <Business />,
    component: <MiEmpresa />,
    noCollapse: true,
    permiso: "Empresa",
  },
  {
    type: "collapse",
    name: "Dec. Juradas",
    key: "declaraciones-juradas",
    route: "/declaraciones-juradas",
    permissionId: 201,
    icon: <Assignment />,
    component: <DeclaracionesJuradas />,
    noCollapse: true,
    permiso: "DDJJ",
  },
  {
    route: "/declaracion/:idEmpresa/:idResponsable/:actividad/:id",
    permissionId: 201,
    component: <DeclaracionJurada />,
    permiso: "DDJJ",
  },
  {
    route: "/declaracion-pdf/:id",
    permissionId: 201,
    component: <PdfDeclaracion />,
    permiso: "DDJJ",
  },
  {
    route: "/error",
    component: <ErrorHandler />,
  },
  {
    route: "/login",
    component: <SignIn />,
  },
  {
    route: "/preinscripcion",
    component: <Preinscripcion />,
  },
];

export default routes;
